import styled from '@emotion/styled';
import KizenTypography from 'app/kizentypo';
import { fontWeights, fontSizes } from 'app/typography';
import Card from 'components/Card/Card';

export const Container = styled.div`
  max-width: 820px;
  width: auto;
  margin: 10px auto;
  background-color: unset;
  & > div {
    margin: 20px auto;
    max-width: 100%;
  }
`;

export const StyledHeader = styled(KizenTypography)<{
  children: any;
  type?: string;
  margin?: string;
}>`
  text-align: center;
  width: 100%;
  margin: 0;
  margin-top: calc(5px - 2px);
  margin-bottom: calc(2 * 15px - 7px);
`;

export const StyledCard = styled(Card)`
  padding: 20px;
`;

export const StyledInfoBox = styled.div`
  padding: 8px 12px;
  border-radius: 4px;
  background-color: var(--color-feedback-info-bg);
`;

export const StyledParagraph = styled.p`
  margin: 0;
  font-size: ${fontSizes.text};
  line-height: 110%;
  color: var(--color-font-primary);
`;

export const StyledIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 20px;
`;

export const StyledContactIcon = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  :hover {
    text-decoration: none;
  }
  > span {
    margin-top: 10px;
    font-style: normal;
    font-weight: ${fontWeights.bold};
    font-size: ${fontSizes.subheader};
    line-height: 100%;
    color: var(--color-font-primary);
  }
`;
